import React from 'react';

export default function Indices({ indices }) {
  return (
    <>
      <ul className="prodct-chart-list max-w-[350px] mx-auto">
        <li className="flex flex-wrap items-center md:items-start md:flex-col mb-3 md:mb-0">
          <div className="cell text-tiny md:text-sm md:mb-3 text-gray-600 w-[100px] md:w-full text-left md:text-right pl-2.5">
            عملکرد و کارایی
          </div>
          <div className="cell flex-1 md:flex-[0_0_75%] max-w-[75%] md:w-full">
            <div
              className="rating-general relative h-[4px] md:h-[10px]  rounded-md bg-light-gray-150"
              data-rating={
                indices?.performance ? `${indices.performance * 20}%` : `0%`
              }
            ></div>
            <div
              className="rating-value bg-color-primary h-[4px] md:h-[10px] rounded-md relative bottom-[4px] md:bottom-[10px]"
              style={{
                width: indices?.worth ? `${indices.performance * 20}%` : `0`,
              }}
            ></div>
          </div>
        </li>
        <li className="flex flex-wrap  items-center  md:items-start md:flex-col mb-3 md:mb-0">
          <div className="cell text-tiny md:text-sm md:mb-3 text-gray-600  w-[100px] md:w-full text-left md:text-right pl-2.5">
            ارزش خرید
          </div>
          <div className="cell flex-1 md:flex-[0_0_75%] max-w-[75%] md:w-full">
            <div
              className="rating-general relative h-[4px] md:h-[10px]  rounded-md bg-light-gray-150"
              data-rating={indices?.worth ? `${indices.worth * 20}%` : `0%`}
            ></div>
            <div
              className="rating-value bg-color-primary h-[4px] md:h-[10px]  rounded-md relative bottom-[4px]  md:bottom-[10px]"
              style={{
                width: indices?.worth ? `${indices.worth * 20}%` : `0`,
              }}
            ></div>
          </div>
        </li>
        <li className="flex flex-wrap md:flex-col  md:items-start items-center mb-3 md:mb-0">
          <div className="cell text-tiny md:text-sm md:mb-3 text-gray-600   w-[100px] md:w-full text-left md:text-right pl-2.5">
            کیفیت
          </div>
          <div className="cell flex-1 md:flex-[0_0_75%] max-w-[75%] md:w-full">
            <div
              className="rating-general relative h-[4px] md:h-[10px]  rounded-md bg-light-gray-150"
              data-rating={indices?.quality ? `${indices.quality * 20}%` : `0%`}
            ></div>
            <div
              className="rating-value bg-color-primary h-[4px] md:h-[10px]  rounded-md relative bottom-[4px]  md:bottom-[10px]"
              style={{
                width: indices?.quality ? `${indices.quality * 20}%` : `0`,
              }}
            ></div>
          </div>
        </li>
        <li className="flex flex-wrap md:flex-col  md:items-start  items-center mb-3 md:mb-0">
          <div className="cell text-tiny md:text-sm md:mb-3 text-gray-600  w-[100px] md:w-full text-left md:text-right pl-2.5">
            دوام
          </div>
          <div className="cell flex-1 md:flex-[0_0_75%] max-w-[75%] md:w-full">
            <div
              className="rating-general relative h-[4px] md:h-[10px]  rounded-md bg-light-gray-150"
              data-rating={
                indices?.durability ? `${indices.durability * 20}%` : `0%`
              }
            ></div>
            <div
              className="rating-value bg-color-primary h-[4px] md:h-[10px] rounded-md relative bottom-[4px]  md:bottom-[10px]"
              style={{
                width: indices?.durability
                  ? `${indices.durability * 20}%`
                  : `0`,
              }}
            ></div>
          </div>
        </li>
      </ul>
    </>
  );
}
